export default function transformNumber(value: string | number): string {
  return new Intl.NumberFormat('en', { maximumFractionDigits: 3 }).format(Number(value)).replace(/,/g, ' ');
}
